import { useState, useEffect, forwardRef } from "react";
import axios from "axios";
import "./OracleLkmAwards.css";
import HangingMenus from "./components/HangingMenus.jsx";
import { baseUrl } from "../Constant.js";
import { imageBaseUrl } from "../Constant.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendarAlt } from "react-icons/fa";
import { awardProfileMap } from "./data/awardData.js";
import Backdrop from "@mui/material/Backdrop";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { BiDownload } from "react-icons/bi";
import { BiUpload } from "react-icons/bi";
import fileDownload from "js-file-download";
import { useMsal } from "@azure/msal-react";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";

import DiamondCertificationsChart from "./components/DiamondCertificationsChart.jsx";
import EditIcon from "@mui/icons-material/Edit";

const AdminUsers = [
  "uma.rani.battu",
  "h.srinivasan",
  "varsha.a.tyagi",
  "jeevadharani.ramanan",
  "vinod.manoharan",
  "ankur.e.mishra",
  "aayushi.bharti",
  "lavanya.umesh",
  "devika.gajanan.pote",
  "srikanth.narabathoju",
  "dhaval.atul.pantojee",
];

const awardTrophyMap = {
  gold: "gold.png",
  silver: "trophysilver.png",
  bronze: "bronze.svg",
  diamond: "trophydiamond.png",
  "referee legends": "referee-legends.png",
};

const formatMonthForAPI = (date) => {
  if (!date) return "";
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = String(date.getFullYear()).slice(-2);
  return `${month}-${year}`;
};

const MonthPickerInput = forwardRef(({ value, onClick }, ref) => (
  <button className="oracle-month-picker-btn" onClick={onClick} ref={ref}>
    <FaRegCalendarAlt className="oracle-calendar-icon" />
    {value || "Select Month"}
  </button>
));

const OracleLkmAwards = () => {
  const [activeTab, setActiveTab] = useState("gold");
  const getPreviousMonth = () => {
    const d = new Date();
    d.setMonth(d.getMonth() - 1);
    return d;
  };

  const [selectedMonth, setSelectedMonth] = useState(getPreviousMonth());
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteScopeDialogOpen, setDeleteScopeDialogOpen] = useState(false);
  const [finalDeleteDialogOpen, setFinalDeleteDialogOpen] = useState(false);
  const [deleteScope, setDeleteScope] = useState(null);
  const [selectedAwardId, setSelectedAwardId] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [uploadMonth, setUploadMonth] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);
  const [selectedProfileAward, setSelectedProfileAward] = useState(null);
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [removeImage, setRemoveImage] = useState(false);
  const [isProfileUploading, setIsProfileUploading] = useState(false);
  const [isUserPresent, setIsUserPresent] = useState(false);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const defaultAvatar =
    process.env.PUBLIC_URL + "/images/Oracle/awards/Avatar.png";

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();

  const loggedInEnterpriseId = activeAccount?.idTokenClaims?.enterpriseID || "";
  console.log("Logged in user enterprise ID:", loggedInEnterpriseId);
  const loggedInUserName = activeAccount?.name || "";
  const loggedInEmail =
    activeAccount?.idTokenClaims?.preferred_username?.toLowerCase();

  const isAdmin = AdminUsers.includes(loggedInEnterpriseId);

  const [awardsData, setAwardsData] = useState({
    gold: [],
    silver: [],
    bronze: [],
    referee: [],
    diamond: [],
  });

  const tabList = [
    { key: "gold", label: "Gold" },
    { key: "silver", label: "Silver" },
    { key: "bronze", label: "Bronze" },
    { key: "referee", label: "Referee Legends" },
    { key: "diamond", label: "Diamond" },
  ];

  const fetchAwards = async () => {
    try {
      const monthParam = formatMonthForAPI(selectedMonth);

      const res = await axios.get(`${baseUrl}/oracle-awards`, {
        params: { month: monthParam, _t: Date.now() },
        headers: {
          Authorization: localStorage.getItem("token"),
          "Cache-Control": "no-cache",
        },
      });

      const grouped = {
        gold: [],
        silver: [],
        bronze: [],
        referee: [],
        diamond: [],
      };

      res.data.forEach((item) => {
        const type = item.award_type.toLowerCase();

        if (type === "gold") grouped.gold.push(item);
        else if (type === "silver") grouped.silver.push(item);
        else if (type === "bronze") grouped.bronze.push(item);
        else if (type.includes("referee")) grouped.referee.push(item);
        else if (type === "diamond") grouped.diamond.push(item);
      });

      setAwardsData(grouped);
    } catch (err) {
      console.error("Fetch awards failed", err);
    }
  };

  useEffect(() => {
    fetchAwards();
    handleActiveTabChange(activeTab);
  }, [selectedMonth]);

  const handleActiveTabChange = (activeTab) => {
    setActiveTab(activeTab);
    checkUserPresent(awardsData[activeTab]);
  };

  const checkUserPresent = async (items) => {
    let flag = false;
    for (let i = 0; i < items.length; i++) {
      if (items[i].email && items[i].email.toLowerCase() === loggedInEmail) {
        flag = true;
        break;
      }
    }

    if (flag) {
      setIsUserPresent(true);
    } else {
      setIsUserPresent(false);
    }
  };

  const handleDownloadBadge = async () => {
    // 1. Define the source URLs
    const badgeUrl = `${process.env.PUBLIC_URL}/images/Oracle/awards/${activeTab}_badge.png`;
    // const userImageUrl = awardsData[activeTab][0]?.profile_image
    //   ? `${imageBaseUrl}/${awardsData[activeTab][0]?.profile_image}`
    //   : defaultAvatar;
    const userImageUrl = awardsData[activeTab].find(
      (item) => item.email?.toLowerCase() === loggedInEmail,
    )?.profile_image
      ? `${imageBaseUrl}/${awardsData[activeTab].find((i) => i.email?.toLowerCase() === loggedInEmail).profile_image}`
      : defaultAvatar;

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const loadImg = (src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous"; // Prevents "tainted canvas" errors
        img.onload = () => resolve(img);
        img.onerror = reject;
        img.src = src;
      });
    };

    try {
      const [badgeImg, profileImg] = await Promise.all([
        loadImg(badgeUrl),
        loadImg(userImageUrl),
      ]);

      // Set canvas to badge dimensions
      canvas.width = badgeImg.width;
      canvas.height = badgeImg.height;

      // Draw Badge
      ctx.drawImage(badgeImg, 0, 0);

      const sizePercentage = 0.7;
      const verticalOffset = 0.0085;
      // Calculate center for profile image
      // You might need to adjust these offsets based on your specific badge design
      const size = canvas.width * sizePercentage; // Profile pic size (40% of badge width)
      const x = (canvas.width - size) / 2;
      const y = (canvas.height - size) / 2 - canvas.height * verticalOffset; // Adjust Y if center isn't perfect

      // Create circular clipping path for profile image
      ctx.save();
      ctx.beginPath();
      ctx.arc(x + size / 2, y + size / 2, size / 2, 0, Math.PI * 2);
      ctx.closePath();
      ctx.clip();

      // Draw Profile Image
      ctx.drawImage(profileImg, x, y, size, size);
      ctx.restore();

      // Trigger Download
      const link = document.createElement("a");
      link.download = `${activeTab}_award_personalized.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (err) {
      console.error("Error generating badge:", err);
      setSnackbar({
        open: true,
        message: "Failed to generate personalized badge.",
        severity: "error",
      });
    }
  };

  const handleUpload = async () => {
    if (!uploadMonth || !uploadFile) {
      setSnackbar({
        open: true,
        message: "Please select month and excel file",
        severity: "warning",
      });
      return;
    }

    const monthParam = formatMonthForAPI(uploadMonth);

    const formData = new FormData();
    formData.append("file", uploadFile);
    formData.append("month", monthParam);

    try {
      await axios.post(`${baseUrl}/upload-awards`, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "multipart/form-data",
        },
      });

      setSnackbar({
        open: true,
        message: "Awards uploaded successfully",
        severity: "success",
      });
      setSelectedMonth(uploadMonth);
      setShowUploadModal(false);
      setUploadFile(null);
      setUploadMonth(null);
    } catch (err) {
      setSnackbar({
        open: true,
        message:
          err.response?.data?.message || "Upload failed. Please try again.",
        severity: "error",
      });
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const openProfileDialog = (item) => {
    setSelectedProfileAward(item);
    setSelectedImageFile(null);
    setRemoveImage(false);
    setProfileDialogOpen(true);
  };

  const closeProfileDialog = () => {
    setProfileDialogOpen(false);
    setSelectedProfileAward(null);
    setSelectedImageFile(null);
    setRemoveImage(false);
  };

  const resetDeleteFlow = () => {
    setDeleteScope(null);
    setDeleteScopeDialogOpen(false);
    setFinalDeleteDialogOpen(false);
  };

  const handleImageSelect = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!["image/jpeg", "image/png", "image/jpg"].includes(file.type)) {
      setSnackbar({
        open: true,
        message: "Only JPG and PNG images are allowed",
        severity: "error",
      });
      e.target.value = "";
      return;
    }

    const maxSizeInBytes = 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      setSnackbar({
        open: true,
        message: "Image size must be less than 1 MB",
        severity: "error",
      });
      e.target.value = "";
      return;
    }

    setSelectedImageFile(file);
    setRemoveImage(false);

    e.target.value = "";
  };

  const handleRemoveImage = () => {
    setSelectedImageFile(null);
    setRemoveImage(true);

    setSelectedProfileAward((prev) =>
      prev ? { ...prev, profile_image: null } : prev,
    );
  };

  const openDeleteDialog = (awardId) => {
    setSelectedAwardId(awardId);
    setDeleteDialogOpen(true);
  };

  const closeDeleteDialog = () => {
    setDeleteDialogOpen(false);
    setSelectedAwardId(null);
  };

  const confirmDeleteAll = async () => {
    try {
      const monthParam = formatMonthForAPI(selectedMonth);

      if (deleteScope === "MONTH") {
        await axios.delete(`${baseUrl}/oracle-awards/month/${monthParam}`, {
          headers: { Authorization: localStorage.getItem("token") },
        });

        setAwardsData({
          gold: [],
          silver: [],
          bronze: [],
          referee: [],
          diamond: [],
        });
      }

      if (deleteScope === "TYPE") {
        await axios.delete(
          `${baseUrl}/oracle-awards/month/${monthParam}/type/${activeTab}`,
          { headers: { Authorization: localStorage.getItem("token") } },
        );

        setAwardsData((prev) => ({
          ...prev,
          [activeTab]: [],
        }));
      }

      setSnackbar({
        open: true,
        message: "Awards deleted successfully",
        severity: "success",
      });

      resetDeleteFlow();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.response?.data?.message || "Delete failed",
        severity: "error",
      });
    }
  };

  const confirmDeleteAward = async () => {
    try {
      await axios.delete(`${baseUrl}/oracle-awards/${selectedAwardId}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });

      setSnackbar({
        open: true,
        message: "Award deleted successfully",
        severity: "success",
      });

      setAwardsData((prev) => ({
        ...prev,
        [activeTab]: prev[activeTab].filter(
          (award) => award.id !== selectedAwardId,
        ),
      }));

      closeDeleteDialog();
    } catch (err) {
      setSnackbar({
        open: true,
        message: err.response?.data?.message || "Delete failed",
        severity: "error",
      });
    }
  };

  const getTabMessage = () => {
    if (activeTab === "silver") {
      return "Silver Trophy results will be announced at the end of Q2.";
    }

    if (activeTab === "referee") {
      return "Referee Legends results will be announced at the end of Q2.";
    }

    if (activeTab === "diamond") {
      return "Diamond Trophy leaderboard will be published soon.";
    }

    return "";
  };

  const handleSaveProfile = async () => {
    if (!selectedProfileAward) return;

    const awardId = selectedProfileAward.id;

    setIsProfileUploading(true);

    try {
      const formData = new FormData();
      formData.append("id", awardId);

      if (selectedImageFile) {
        formData.append("image", selectedImageFile);
        formData.append("remove", "false");
      } else if (removeImage) {
        formData.append("remove", "true");
      }

      const res = await axios.put(
        `${baseUrl}/oracle-awards/profile-image`,
        formData,
        {
          headers: {
            Authorization: localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const newImage = res.data.profile_image;

      setAwardsData((prev) => {
        const updated = { ...prev };
        Object.keys(updated).forEach((tab) => {
          updated[tab] = updated[tab].map((award) =>
            award.id === awardId
              ? { ...award, profile_image: newImage }
              : award,
          );
        });
        return updated;
      });

      setSnackbar({
        open: true,
        message: "Profile picture updated successfully",
        severity: "success",
      });

      closeProfileDialog();

      setSelectedImageFile(null);
      setRemoveImage(false);
    } catch (error) {
      console.error(error);
      setSnackbar({
        open: true,
        message: "Failed to update profile picture",
        severity: "error",
      });
    } finally {
      setIsProfileUploading(false);
      setSelectedImageFile(null);
      setRemoveImage(false);
    }
  };

  const isSaveEnabled = Boolean(selectedImageFile || removeImage);
  const formatDisplayName = (name = "") =>
    name.replace(/\./g, " ").replace(/\s+/g, " ").trim();

  const MIN_MONTH = new Date(2025, 10);
  const MAX_MONTH = new Date();

  return (
    <>
      <div className="oracle-awards-banner">
        <img
          src={process.env.PUBLIC_URL + "/images/Oracle/awards/walloffame.png"}
          alt="Awards Banner"
        />
      </div>

      <div className="oracle-awards-body">
        <div className="oracle-awards-content-header">
          <div className="oracle-awards-content">
            <p>
              The Wall of Fame page highlights and honors individuals who have
              excelled in the Oracle Power Up League Program and Certification.
              It serves as a platform to recognize their dedication,
              achievements, and expertise, inspiring others to strive for
              excellence in Oracle technologies.
            </p>
          </div>
          <div className="oracle-awards-controls-row">
            <div className="oracle-awards-controls">
              <DatePicker
                selected={selectedMonth}
                onChange={(date) => setSelectedMonth(date)}
                showMonthYearPicker
                dateFormat="MMMM yyyy"
                minDate={MIN_MONTH}
                maxDate={MAX_MONTH}
                customInput={<MonthPickerInput />}
              />
              {isAdmin && (
                <button
                  className="oracle-upload-btn"
                  onClick={() => setShowUploadModal(true)}
                >
                  Upload File
                </button>
              )}

              {isAdmin && (
                <a
                  href={`${process.env.PUBLIC_URL}/templates/Oracle-Awards-Upload-Template.xlsx`}
                  download="Oracle-Awards-Upload-Template.xlsx"
                  className="oracle-download-btn"
                >
                  Download Template
                  <BiDownload size={18} />
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="oracle-awards-tabs">
          {tabList.map((tab) => (
            <div
              key={tab.key}
              className={`oracle-awards-tab ${
                activeTab === tab.key ? "active" : ""
              }`}
              onClick={() => handleActiveTabChange(tab.key)}
            >
              {tab.label}
              {tab.key !== "diamond" && ` - ${awardsData[tab.key].length}`}

              <div
                className={`oracle-awards-arrow-down ${
                  activeTab === tab.key ? "active" : ""
                }`}
              />
            </div>
          ))}
        </div>

        {isAdmin &&
          activeTab !== "diamond" &&
          awardsData[activeTab]?.length > 0 && (
            <div className="oracle-delete-all-container">
              {isUserPresent && (
                <button
                  className="oracle-download-btn flex-first"
                  onClick={handleDownloadBadge}
                >
                  {"Download Badge"}
                  <BiDownload size={18} />
                </button>
              )}
              <button
                className="oracle-delete-all-btn"
                onClick={() => setDeleteScopeDialogOpen(true)}
              >
                Delete Awards
              </button>
            </div>
          )}

        <div className="oracle-awards-cards-block">
          {activeTab === "diamond" ? (
            <DiamondCertificationsChart isAdmin={isAdmin} />
          ) : ["silver", "referee"].includes(activeTab) &&
            awardsData[activeTab].length === 0 ? (
            <div className="oracle-awards-coming-soon">
              <h2>{getTabMessage()}</h2>
            </div>
          ) : (
            <div className="oracle-awards-cards">
              {awardsData[activeTab].map((item, index) => {
                const isOwnCard =
                  loggedInEmail &&
                  item.email &&
                  loggedInEmail === item.email.toLowerCase();

                const canEditProfile = isAdmin || isOwnCard;

                return (
                  <div key={item.id} className="oracle-awards-card">
                    {isAdmin && (
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          openDeleteDialog(item.id);
                        }}
                      >
                        <DeleteIcon
                          className="oracle-awards-delete-icon"
                          titleAccess="Delete Award"
                        />
                      </div>
                    )}

                    <div className="oracle-awards-cards-top">
                      <img
                        className="oracle-awards-cards-trophy"
                        src={`${process.env.PUBLIC_URL}/images/Oracle/awards/${
                          awardTrophyMap[item.award_type.toLowerCase()]
                        }`}
                        alt="trophy"
                      />
                    </div>

                    <div className="oracle-awards-cards-bottom">
                      <div className="profile-image-wrapper">
                        <img
                          className="oracle-awards-cards-profile-img"
                          src={
                            item.profile_image
                              ? `${imageBaseUrl}/${
                                  item.profile_image
                                }?t=${Date.now()}`
                              : `${process.env.PUBLIC_URL}/images/Oracle/awards/Avatar.png`
                          }
                          alt="profile"
                          onError={(e) => {
                            e.target.src = `${process.env.PUBLIC_URL}/images/Oracle/awards/Avatar.png`;
                          }}
                        />

                        {canEditProfile && (
                          <IconButton
                            className="profile-edit-btn"
                            size="small"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              openProfileDialog(item);
                            }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        )}
                      </div>
                      <h3>{formatDisplayName(item.name)}</h3>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {showUploadModal && (
        <div className="oracle-modal-overlay">
          <div className="oracle-modal">
            <h3>Upload Awards Excel</h3>

            <label>Select Month</label>
            <DatePicker
              selected={uploadMonth}
              onChange={(date) => setUploadMonth(date)}
              showMonthYearPicker
              dateFormat="MMMM yyyy"
              minDate={MIN_MONTH}
              maxDate={MAX_MONTH}
              customInput={<MonthPickerInput />}
            />

            <label>Choose Excel File</label>
            <input
              type="file"
              accept=".xls,.xlsx"
              onChange={(e) => setUploadFile(e.target.files[0])}
            />

            <div className="oracle-modal-actions">
              <button
                className="btn-cancel"
                onClick={() => setShowUploadModal(false)}
              >
                Cancel
              </button>
              <button className="btn-upload" onClick={handleUpload}>
                Upload
              </button>
            </div>
          </div>
        </div>
      )}

      <Dialog open={deleteScopeDialogOpen} onClose={resetDeleteFlow}>
        <DialogTitle
          sx={{
            position: "relative",
            pr: 5,
          }}
        >
          <span>Delete Awards – {formatMonthForAPI(selectedMonth)}</span>

          <IconButton
            aria-label="close"
            onClick={resetDeleteFlow}
            sx={{
              position: "absolute",
              right: -50,
              top: 0,
              color: "#666",
              "&:hover": {
                color: "#000",
                backgroundColor: "rgba(0,0,0,0.05)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <DialogContentText>What would you like to delete?</DialogContentText>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "space-between", px: 2 }}>
          <Button
            color="error"
            variant="outlined"
            onClick={() => {
              setDeleteScope("TYPE");
              setDeleteScopeDialogOpen(false);
              setFinalDeleteDialogOpen(true);
            }}
          >
            Delete only {activeTab.toUpperCase()}
          </Button>

          <Button
            color="error"
            variant="contained"
            onClick={() => {
              setDeleteScope("MONTH");
              setDeleteScopeDialogOpen(false);
              setFinalDeleteDialogOpen(true);
            }}
          >
            Delete entire month
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={finalDeleteDialogOpen} onClose={resetDeleteFlow}>
        <DialogTitle>Confirm Delete</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete{" "}
            <b>
              {deleteScope === "MONTH"
                ? `ALL awards for ${formatMonthForAPI(selectedMonth)}`
                : `${activeTab.toUpperCase()} awards for ${formatMonthForAPI(
                    selectedMonth,
                  )}`}
            </b>
            ?
            <br />
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={resetDeleteFlow}>Cancel</Button>
          <Button color="error" variant="contained" onClick={confirmDeleteAll}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteDialogOpen}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;
          closeDeleteDialog();
        }}
      >
        {/* <DialogTitle>Delete Award</DialogTitle> */}
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this award?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={closeDeleteDialog}>Cancel</Button>
          <Button
            onClick={confirmDeleteAward}
            color="error"
            variant="contained"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={profileDialogOpen}
        onClose={closeProfileDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Change your profile picture</DialogTitle>

        <DialogContent sx={{ textAlign: "center" }}>
          <div style={{ margin: "20px 0" }}>
            <img
              src={
                selectedImageFile
                  ? URL.createObjectURL(selectedImageFile)
                  : selectedProfileAward?.profile_image
                    ? `${imageBaseUrl}/${
                        selectedProfileAward.profile_image
                      }?t=${Date.now()}`
                    : `${process.env.PUBLIC_URL}/images/Oracle/awards/Avatar.png`
              }
              alt="profile"
              style={{
                width: "160px",
                height: "160px",
                borderRadius: "50%",
                objectFit: "cover",
                background: "#e8f0e2",
              }}
            />
          </div>

          <div
            style={{ display: "flex", justifyContent: "center", gap: "30px" }}
          >
            <input
              type="file"
              id="profile-upload-input"
              hidden
              accept="image/*"
              onChange={handleImageSelect}
            />

            <Button
              onClick={() =>
                document.getElementById("profile-upload-input").click()
              }
              startIcon={<BiUpload />}
              sx={{
                color: "#7500c0",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "transparent",
                  color: "#5e0099",
                },
              }}
            >
              UPLOAD
            </Button>

            <Button
              color="error"
              startIcon={<DeleteIcon />}
              onClick={handleRemoveImage}
            >
              Remove
            </Button>
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={closeProfileDialog}
            sx={{
              color: "#464748ff",
              "&:hover": {
                backgroundColor: "rgba(107, 114, 128, 0.08)",
              },
            }}
          >
            CLOSE
          </Button>
          <Button
            variant="contained"
            disabled={!isSaveEnabled}
            onClick={handleSaveProfile}
            sx={{
              backgroundColor: "#7500c0",
              "&:hover": {
                backgroundColor: "#5e0099",
              },
              "&.Mui-disabled": {
                backgroundColor: "#d1b3e6",
                color: "#fff",
              },
            }}
          >
            {isProfileUploading ? (
              <CircularProgress size={22} sx={{ color: "white" }} />
            ) : (
              "Save"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{
          mb: "70px",
        }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Backdrop
        open={isProfileUploading}
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 999,
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <HangingMenus />
    </>
  );
};

export default OracleLkmAwards;
